module.exports = __webpack_public_path__ + "sy.svg?0d56cb2b5bea91512b7bc643d5594994";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/sy.svg
// module id = 1138
// module chunks = 27